var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21959 0.719201C0.360236 0.578597 0.550967 0.499611 0.74984 0.499611C0.948713 0.499611 1.13944 0.578597 1.28009 0.719201L4.49984 3.93895L7.71959 0.719201C7.78877 0.647568 7.87153 0.590431 7.96304 0.551125C8.05454 0.511818 8.15295 0.491128 8.25254 0.490263C8.35212 0.489397 8.45088 0.508373 8.54305 0.546084C8.63523 0.583795 8.71897 0.639485 8.78938 0.709904C8.8598 0.780324 8.91549 0.864063 8.95321 0.956235C8.99092 1.04841 9.00989 1.14717 9.00903 1.24675C9.00816 1.34634 8.98747 1.44475 8.94817 1.53625C8.90886 1.62776 8.85172 1.71052 8.78009 1.7797L5.56034 4.99945L8.78009 8.2192C8.91671 8.36065 8.9923 8.5501 8.99059 8.74675C8.98889 8.9434 8.91001 9.13151 8.77095 9.27056C8.6319 9.40962 8.44379 9.4885 8.24714 9.49021C8.05049 9.49191 7.86104 9.41632 7.71959 9.2797L4.49984 6.05995L1.28009 9.2797C1.13864 9.41632 0.949186 9.49191 0.752539 9.49021C0.555891 9.4885 0.367782 9.40962 0.228726 9.27056C0.0896698 9.13151 0.0107929 8.9434 0.0090841 8.74675C0.00737529 8.5501 0.0829714 8.36065 0.21959 8.2192L3.43934 4.99945L0.21959 1.7797C0.0789866 1.63905 0 1.44832 0 1.24945C0 1.05058 0.0789866 0.859846 0.21959 0.719201Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconLight);
export default __webpack_public_path__ + "static/media/x_icon_light.238eb65b8f3799e2b6eb965767f6554c.svg";
export { ForwardRef as ReactComponent };